import React from 'react'
import { graphql, Link } from 'gatsby'
import { RichText } from 'prismic-reactjs'
import Accordeons from '../components/Accordeons'
import Seo from '../components/Seo'

const CareAndMaintenanceTechnology = ({ pageContext, data, location }) => {
	const pageData = data.prismicCareAndMaintenanceTechnology.data

  return (
    <main className="CareAndMaintenanceTechnology" data-menu-color="lBlack,mGrey,sGrey">
			<Seo
				title={`${pageData.name.text} Care and maintenance`}
				description={pageData.meta_description.text}
				url={location.href}
			/>
			<div className="CareAndMaintenance__Left">
				<ul className="CareAndMaintenance__Links">
					{data.prismicCareAndMaintenance.data.technologies_list.map((technology, index) => (
						<li
							className={`CareAndMaintenance__Link bodySansSmall ${technology.technology_page.document.data.name.text === pageData.name.text ? 'isCurrent' : ''}`}
							key={`care-link-${index}`}
						>
							<Link to={`/care-and-maintenance-technologies/${technology.technology_page.slug}`}>
								{technology.technology_page.document.data.name.text}
							</Link>
						</li>
					))}
				</ul>
			</div>
			<div className="CareAndMaintenanceTechnology__Content">
				<img
					src={pageData.logo.fluid.src}
					srcSet={pageData.logo.fluid.srcSet}
					alt={pageData.logo.alt}
					className="CareAndMaintenanceTechnology__Logo"
				/>
				<div className="CareAndMaintenanceTechnology__Header">
					<div className="CareAndMaintenanceTechnology__Intro bodySansSmall">
						<RichText render={pageData.intro.richText}/>
					</div>
					<a
						href={pageData.file_to_download.url}
						target="_blank"
						className="CareAndMaintenanceTechnology__DownloadButton"
					>
						<div className="CareAndMaintenanceTechnology__DownloadButtonLabel caps">Guide</div>
						<svg className="CareAndMaintenanceTechnology__DownloadButtonIcon" viewBox="0 0 10 15" fill="none"><path d="M5 4.37114e-07L5 10.5M5 10.5L9 6.20968M5 10.5L1 6.20968M1.20206e-06 13.75L10 13.75" stroke="#EAE7DD"/></svg>
					</a>
				</div>
				<div className="CareAndMaintenanceTechnology__AccordeonsContainer">
					<Accordeons items={pageData.questions}/>
				</div>
			</div>
    </main>
  )
}

export default CareAndMaintenanceTechnology

export const query = graphql`
	query CareAndMaintenanceTechnologyByUid($uid: String!) {
		prismicCareAndMaintenanceTechnology(uid: {eq: $uid}) {
			data {
				meta_description {
					text
				}
				name {
					text
				}
				logo {
					alt
					fluid {
						src
						srcSet
					}
				}
				intro {
					richText
				}
				file_to_download {
					url
				}
				questions {
					question {
						text
					}
					answer {
						richText
					}
				}
			}
		}
		prismicCareAndMaintenance {
			data {
				technologies_list {
					technology_page {
						slug
						document {
							... on PrismicCareAndMaintenanceTechnology {
								id
								data {
									name {
										text
									}
								}
							}
						}
					}
				}
			}
		}
		prismicBannerAndPopup {
			...BannerAndPopup
			...CookiesNotice
		}
		prismicNewsletter {
			...Newsletter
		}
		prismicFooter {
			...Footer
		}
	}
`